export default "__VITE_ASSET__Bcr1xyDM__"